// SPDX-License-Identifier: AGPL-3.0-or-later

package kairos.web

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp { Surface { content() } }
}
